import type { Chain, ValidationError } from './types.js';

/**
 * Base error class for all txViz errors.
 * Using a dedicated base allows consumers to catch all library errors.
 */
export class TxVizError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TxVizError';
  }
}

/**
 * Thrown when no plugin is registered for the requested chain.
 */
export class UnsupportedChainError extends TxVizError {
  readonly chain: string;

  constructor(chain: string) {
    super(`No plugin registered for chain: "${chain}"`);
    this.name = 'UnsupportedChainError';
    this.chain = chain;
  }
}

/**
 * Thrown when transaction input fails validation.
 */
export class ValidationFailedError extends TxVizError {
  readonly errors: readonly ValidationError[];

  constructor(chain: Chain, errors: readonly ValidationError[]) {
    const details = errors.map((e) => `  ${e.field}: ${e.message}`).join('\n');
    super(`Transaction validation failed for ${chain}:\n${details}`);
    this.name = 'ValidationFailedError';
    this.errors = errors;
  }
}

/**
 * Thrown when serialization produces unexpected results.
 */
export class SerializationError extends TxVizError {
  constructor(chain: Chain, detail: string) {
    super(`Serialization error on ${chain}: ${detail}`);
    this.name = 'SerializationError';
  }
}
